import types from '../types';

const initialState = [];

const liveGames = (
  state = { loading: false, data: initialState, error: null },
  action
) => {
  switch (action.type) {
    case types.GET_LIVE_GAMES_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: null,
      };

    default:
      return state;
  }
};

export default liveGames;
